import React from "react";
import { Link } from "react-router-dom";
import { getSub } from "../common/Navigations";
import useParityAccess, { useSectionOpen } from "../common/useParityAccess";

const HeadNavigation = ({ currentSideNav, handleNav, location }) => {
  const can = useParityAccess();
  const sectionOpen = useSectionOpen();

  const tabsForParent = () =>
    getSub()
      .filter(({ parent }) => parent === currentSideNav?.id)
      .filter((item) => !item.section || sectionOpen(item.section))
      .filter((item) => !item.permission || can(item.permission));

  const isCurrentTab = (nav) => {
    const path = location.pathname;
    const matches = tabsForParent()
      .filter((item) => path === item.to || path.startsWith(`${item.to}/`))
      .sort((a, b) => b.to.length - a.to.length);
    return matches[0]?.to === nav.to ? "active" : "";
  };

  return (
    <div className="header-tab">
      <ul>
        {tabsForParent().map((nav, i) => (
          <Link key={i} to={nav.to}>
            <li key={i} className={isCurrentTab(nav)}>
              {nav.name}
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default HeadNavigation;
